module.exports = __webpack_public_path__ + "img/1f99f.15ea977.svg";